import React from 'react';
import PropTypes from 'prop-types';
import rehypeReact from 'rehype-react';
import { mapIcon } from '../../utils/mappers';
import ImageDisplay from '../imageDisplay';

const ReadyToBook = ({ groupingTitle, subtitle, icons, iconHeight }) => {
	const renderDescAst = new rehypeReact({
		createElement: React.createElement,
		components: {
			p: ({ children }) => (
				<div className="typography typography--body-big typography--secondary">
					{children}
				</div>
			),
			small: ({ children }) => (
				<div className="typography typography--body-small">{children}</div>
			),
		},
	}).Compiler;
	return (
		<div className="ready-to-book">
			<h2 className="typography typography--h2 typography--secondary">{groupingTitle}</h2>
			<p className="typography typography--subtle-big typography--secondary">
				{subtitle}
			</p>
			<div className="ready-to-book__items">
				{icons?.map(mapIcon).map(({ title, icon, description }) => (
					<div className="ready-to-book__items-item" key={title}>
						<figure
							className="ready-to-book__items-item-icon"
							style={{ height: iconHeight }}
						>
							<ImageDisplay
								alt={icon.alt}
								image={icon.data}
								src={icon.src}
							/>
						</figure>
						<div>{renderDescAst(description)}</div>
					</div>
				))}
			</div>
		</div>
	);
};

ReadyToBook.propTypes = {
	groupingTitle: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	className: PropTypes.string,
	icons: PropTypes.arrayOf(
		PropTypes.shape({
			icon: PropTypes.shape({
				data: PropTypes.object,
				src: PropTypes.string,
				alt: PropTypes.string,
			}),
			title: PropTypes.string.isRequired,
			description: PropTypes.object.isRequired,
		})
	).isRequired,
	iconHeight: PropTypes.number,
};

ReadyToBook.defaultProps = {
	subtitle: null,
	icons: [],
	iconHeight: 48,
};

export default ReadyToBook;
